module.exports = __webpack_public_path__ + "src/assets/img/25.d2dbf86f.svg";